import { GeolocationErrorType } from '@/store/slices/geolocation/types';

/**
 * Maximum number of NDBS-error retries a user may trigger before the retry CTA is
 * replaced with a "contact support" CTA. Mirrors the legacy launcher behaviour.
 */
export const MAX_NDBS_RETRIES = 3 as const;

/** SDK callback code emitted when its API rejects the Account credential. */
export const INVALID_SESSION_ERROR_CODE = 401 as const;

/** GeoComply NDBS code when the browser reports HTML5 geolocation permission denied. */
export const HTML5_GEO_ACCESS_DENIED_ERROR_CODE = 803 as const;

/** Automatic re-locate attempts when 803 may be a transient permission race (e.g. Safari). */
export const MAX_TRANSIENT_803_AUTO_RETRIES = 1 as const;

export const TRANSIENT_803_RETRY_DELAY_MS = 500 as const;

export const locationErrorMessageMapper = {
  600: 'Unexpected error occurred.',
  601: 'The geolocation solution is disabled for app client account by administrator at GeoComply Back Office site.',
  602: 'The network connection is not available.',
  603: 'Server communication error',
  604: 'The client account is suspended.',
  605: 'The HTML5 solution is disabled.',
  606: 'The license has invalid format.',
  607: 'The license is unauthorized by server.',
  608: 'The license is expired.',
  609: 'The custom fields list is invalid.',
  611: 'Unable to attain geolocation data from the web browser. This error is reported by the SDK before sending the request to the Engine service.',
  612: '',
  613: '',
  614: 'Previous geolocation is not finished.',
  615: 'PLC not installed',
  620: 'Invalid server Response.',
  630: 'The location data is outdated.',
  635: 'Invalid user ID. This error cancels the request before it reaches the Engine service. The validation logic that determines what the Engine service accepts can be configured in GeoComply Hub.',
  639: 'Reason code is required.',
  640: 'Invalid HMAC.',
  708: 'Failed to validate geopacket',
  801: 'Current browser is incompatible with HTML5 geolocation.',
  802: 'Browser HTML5 geolocation is unavailable.',
  803: 'Browser HTML5 geolocation access denied.',
  804: 'Browser HTML5 geolocation timed out.',
  805: 'Browser HTML5 geolocation unknown problem.',
};

export const locationErrorTypeMapper = {
  600: GeolocationErrorType.NDBS,
  601: GeolocationErrorType.PLC,
  602: GeolocationErrorType.NDBS,
  603: GeolocationErrorType.NDBS,
  604: GeolocationErrorType.NDBS,
  605: GeolocationErrorType.NDBS,
  606: GeolocationErrorType.NDBS,
  607: GeolocationErrorType.NDBS,
  608: GeolocationErrorType.NDBS,
  609: GeolocationErrorType.NDBS,
  611: GeolocationErrorType.NDBS,
  612: GeolocationErrorType.PLC,
  613: GeolocationErrorType.PLC,
  614: GeolocationErrorType.NDBS,
  615: GeolocationErrorType.PLC,
  620: GeolocationErrorType.NDBS,
  630: GeolocationErrorType.NDBS,
  635: GeolocationErrorType.NDBS,
  639: GeolocationErrorType.NDBS,
  640: GeolocationErrorType.NDBS,
  708: GeolocationErrorType.General,
  801: GeolocationErrorType.NDBS,
  802: GeolocationErrorType.NDBS,
  803: GeolocationErrorType.NDBS,
  804: GeolocationErrorType.NDBS,
  805: GeolocationErrorType.NDBS,
};
